import { ClickAwayListener } from "@mui/material";
import React from "react";

interface Props {
  open: boolean;
  onClose: () => unknown;
  children: React.ReactNode;
  wrapperStyle?: object;
}

export const CustomModal = ({
  open,
  onClose,
  children,
  wrapperStyle,
}: Props) => {
  if (!open) return <></>;

  return (
    <ClickAwayListener
      onClickAway={() => {
        onClose();
      }}
    >
      <div
        style={{
          maxHeight: "500px",
          width: "300px",
          borderRadius: "5px",
          overflowY: "hidden",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          padding: "5px",
          ...wrapperStyle,
        }}
      >
        {children}
      </div>
    </ClickAwayListener>
  );
};
